import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ThemeRegistry.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/context/providers.tsx")